import React, { useState, useEffect, useRef } from 'react';
import axios from "axios";
import '../../css/addproperty.css';
import '../../css/addroomdetails.css';
import '../../css/styles.css';
import chennaipincode from '../../assets/pincode.json';
import { useNavigate } from 'react-router-dom';
import { MapContainer, TileLayer, Marker, Popup, useMapEvents } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import markerIconPng from "leaflet/dist/images/marker-icon.png";
import markerShadowPng from "leaflet/dist/images/marker-shadow.png";
import Dashboard from './Dashboard';


const customIcon = new L.Icon({
  iconUrl: markerIconPng,
  shadowUrl: markerShadowPng,
  iconSize: [25, 41],
  iconAnchor: [12, 41]
});

const LocationSelector = ({ setPosition, setAddress }) => {
  useMapEvents({
    click: async (e) => {
      const { lat, lng } = e.latlng;
      setPosition([lat, lng]);

      // Fetch address using reverse geocoding
      try {
        const response = await fetch(
          `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}`
        );
        const data = await response.json();
        if (data.display_name) {
          setAddress(data.display_name);
        } else {
          setAddress("Address not found");
        }
      } catch (error) {
        console.error("Error fetching address:", error);
      }
    }
  });

  return null;
};


const steps = [
  { id: 1, label: "Property Details" },
  { id: 2, label: "Address" },
  { id: 3, label: "Photos" },
  { id: 4, label: "Verify" },
  { id: 5, label: "Review" },
];



export const AddPropertyResidentialRent1 = ({ agent_id, agent_name}) => {


  const pincodeData = chennaipincode;
 const [currentStep, setCurrentStep] = useState(1);
  const [step, setStep] = useState(1);
  const [propertyType, setPropertyType] = useState("");
  const [lookingTo, setLookingTo] = useState("");
  const [city, setCity] = useState("");
  const [building, setBuilding] = useState("");
  const [propertyType1, setPropertyType1] = useState("");
  const [bhkType, setBhkType] = useState("");
  const [builtUpArea, setBuiltUpArea] = useState("");
  const [propertyAge, setPropertyAge] = useState("");
  const [searchTerm, setSearchTerm] = useState('');
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [selectedPincode, setSelectedPincode] = useState('');
  const [localities, setLocalities] = useState([]);
  const [selectedLocality, setSelectedLocality] = useState('');
  const [bathroom, setBathroom] = useState();
  const [balcony, setBalcony] = useState();
  const [furnishType, setFurnishType] = useState("");
  const [coveredParking, setCoveredParking] = useState(0);
  const [openParking, setOpenParking] = useState(0);
  const [tenantType, setTenantType] = useState("");
  const [petFriendly, setPetFriendly] = useState("");
  const [brokerage, setBrokerage] = useState("");
  const [floorNo, setFloorNo] = useState("");
  const [totalFloors, setTotalFloors] = useState("");
  const [BuildingDetails, setBuildingDetails] = useState("");
  const [facing, setFacing] = useState("");
  const [servantRoom, setServantRoom] = useState("");
  const [propertyDescription, setPropertyDescription] = useState("");
  const [availableFrom, setavailableFrom] = useState("");
  const [monthlyrent, setMonthlyrent] = useState("");
  const [maintenanceCharges, setMaintenanceCharges] = useState("");
  const [securityDeposit, setSecurityDeposit] = useState("");
  const [lockInPeriod, setLockInPeriod] = useState("");
  const [carpetArea, setCarpetArea] = useState("");
  const [parkingCharges, setParkingCharges] = useState("");
  const [paintingCharges, setPaintingCharges] = useState("");
  const [showAdditional, setShowAdditional] = useState(false);
  const [Address, setAddress] = useState("");
  const [locality, setLocality] = useState(""); // Default locality
  const [position, setPosition] = useState([12.9784, 80.2184]); // Default Lat/Lng for Velachery
  const [paraaddress, setParaAddress] = useState("");
  const [images, setImages] = useState([]);
  const [videos, setVideos] = useState([]);
  const [errors, setErrors] = useState({propertyType:'', lookingTo:''});

  const propertyTypeRef = useRef(null);
const lookingToRef = useRef(null);
const cityRef = useRef(null);
const buildingRef = useRef(null);
const pincodeRef = useRef(null);
const propertyType1Ref = useRef(null);
const bhkTypeRef = useRef(null);
const builtUpAreaRef = useRef(null);
const propertyAgeRef = useRef(null);
const bathroomRef = useRef(null);
const balconyRef = useRef(null);
const furnishTypeRef = useRef(null);
const tenantTypeRef = useRef(null);
const petFriendlyRef = useRef(null);
const propertyDescriptionRef = useRef(null);
const availableFromRef = useRef(null);
const monthlyrentRef = useRef(null);
const maintenanceChargesRef = useRef(null);
const securityDepositRef = useRef(null);
const lockInPeriodRef = useRef(null);
const brokerageRef = useRef(null);
const carpetAreaRef = useRef(null);
const floorNoRef = useRef(null);
const totalFloorsRef = useRef(null);
const localityRef = useRef(null);

const getRefByKey = (key) => {
  switch (key) {
      case 'propertyType':
          return propertyTypeRef;
      case 'lookingTo':
          return lookingToRef;
      case 'city':
          return cityRef;
      case 'building':
          return buildingRef;
      case 'pincode':
          return pincodeRef;
      case 'selectedLocality':
          return localityRef; //add localityRef if not present
      case 'propertyType1':
          return propertyType1Ref;
      case 'bhkType':
          return bhkTypeRef;
      case 'builtUpArea':
          return builtUpAreaRef;
      case 'propertyAge':
          return propertyAgeRef;
      case 'bathroom':
          return bathroomRef;
      case 'balcony':
          return balconyRef;
      case 'furnishType':
          return furnishTypeRef;
      case 'tenantType':
          return tenantTypeRef;
      case 'petFriendly':
          return petFriendlyRef;
      case 'propertyDescription':
          return propertyDescriptionRef;
      case 'monthlyrent':
          return monthlyrentRef;
      case 'maintenanceCharges':
          return maintenanceChargesRef;
      case 'securityDeposit':
          return securityDepositRef;
      case 'lockInPeriod':
          return lockInPeriodRef;
      case 'brokerage':
          return brokerageRef;
      case 'carpetArea':
          return carpetAreaRef;
      case 'floorNo':
          return floorNoRef;
      case 'totalFloors':
          return totalFloorsRef;
      //add more cases if needed
      default:
          return null;
  }
};


const validateForm = () => {
  let isValid = true;
  const newErrors = { ...errors }; // Create a copy of the existing errors

  // Validate Property Type
  if (!propertyType) {
      newErrors.propertyType = 'Property type is required';
      isValid = false;
  } else {
      newErrors.propertyType = '';
  }

  // Validate Looking To
  if (!lookingTo) {
      newErrors.lookingTo = 'Looking to is required';
      isValid = false;
  } else {
      newErrors.lookingTo = '';
  }

  // Validate City
  if (!city) {
      newErrors.city = 'City is required';
      isValid = false;
  } else {
      newErrors.city = '';
  }

  // Validate Building
  if (!building) {
      newErrors.building = 'Building is required';
      isValid = false;
  } else {
      newErrors.building = '';
  }

  // Validate Pincode
  if (!selectedPincode) {
      newErrors.pincode = 'Pincode is required';
      isValid = false;
  } else {
      newErrors.pincode = '';
  }

  // Validate Locality
  if (!selectedLocality) {
      newErrors.selectedLocality = 'Locality is required';
      isValid = false;
  } else {
      newErrors.selectedLocality = '';
  }

  // Validate Property Type 1
  if (!propertyType1) {
      newErrors.propertyType1 = 'Property type is required';
      isValid = false;
  } else {
      newErrors.propertyType1 = '';
  }

  // Validate BHK Type
  if (!bhkType) {
      newErrors.bhkType = 'BHK type is required';
      isValid = false;
  } else {
      newErrors.bhkType = '';
  }

  // Validate Built-up Area
  if (!builtUpArea) {
      newErrors.builtUpArea = 'Built-up area is required';
      isValid = false;
  } else if (builtUpArea <= 0) {
      newErrors.builtUpArea = 'Built-up area must be greater than 0';
      isValid = false;
  } else {
      newErrors.builtUpArea = '';
  }

  // Validate Property Age
  if (!propertyAge) {
      newErrors.propertyAge = 'Property age is required';
      isValid = false;
  } else if (propertyAge < 0) {
      newErrors.propertyAge = 'Property age cannot be negative';
      isValid = false;
  } else {
      newErrors.propertyAge = '';
  }

  // Validate Bathroom
  if (!bathroom) {
      newErrors.bathroom = 'Bathroom count is required';
      isValid = false;
  } else {
      newErrors.bathroom = '';
  }

  // Validate Balcony
  if (balcony === null) { //check if balcony is null, if the user didnt click any button.
      newErrors.balcony = 'Balcony count is required';
      isValid = false;
  } else {
      newErrors.balcony = '';
  }

  // Validate Furnish Type
  if (!furnishType) {
      newErrors.furnishType = 'Furnish type is required';
      isValid = false;
  } else {
      newErrors.furnishType = '';
  }

  // Validate Tenant Type
  if (!tenantType) {
      newErrors.tenantType = 'Tenant type is required';
      isValid = false;
  } else {
      newErrors.tenantType = '';
  }

  // Validate Pet Friendly
  if (!petFriendly) {
      newErrors.petFriendly = 'Pet friendly selection is required';
      isValid = false;
  } else {
      newErrors.petFriendly = '';
  }

  // Validate Property Description
  if (!propertyDescription) {
      newErrors.propertyDescription = 'Property description is required';
      isValid = false;
  } else {
      newErrors.propertyDescription = '';
  }

  // Validate Monthly Rent
  if (!monthlyrent) {
      newErrors.monthlyrent = 'Monthly rent is required';
      isValid = false;
  } else if (monthlyrent <= 0) {
      newErrors.monthlyrent = 'Monthly rent must be greater than 0';
      isValid = false;
  } else {
      newErrors.monthlyrent = '';
  }

  // Validate Maintenance Charges
  if (!maintenanceCharges) {
      newErrors.maintenanceCharges = 'Maintenance charges selection is required';
      isValid = false;
  } else {
      newErrors.maintenanceCharges = '';
  }

  // Validate Security Deposit
  if (!securityDeposit) {
      newErrors.securityDeposit = 'Security deposit selection is required';
      isValid = false;
  } else {
      newErrors.securityDeposit = '';
  }

  // Validate Lock-in Period
  if (!lockInPeriod) {
      newErrors.lockInPeriod = 'Lock-in period selection is required';
      isValid = false;
  } else {
      newErrors.lockInPeriod = '';
  }

  // Validate Brokerage
  if (!brokerage) {
      newErrors.brokerage = 'Brokerage selection is required';
      isValid = false;
  } else {
      newErrors.brokerage = '';
  }

  // Validate Carpet Area
  if (!carpetArea) {
      newErrors.carpetArea = 'Carpet area is required';
      isValid = false;
  } else if (carpetArea <= 0) {
      newErrors.carpetArea = 'Carpet area must be greater than 0';
      isValid = false;
  } else {
      newErrors.carpetArea = '';
  }

  // Validate Floor No
  if (!floorNo) {
      newErrors.floorNo = 'Floor number is required';
      isValid = false;
  } else {
      newErrors.floorNo = '';
  }

  // Validate Total Floors
  if (!totalFloors) {
      newErrors.totalFloors = 'Total floors is required';
      isValid = false;
  } else {
      newErrors.totalFloors = '';
  }

  // Update the errors state
  setErrors(newErrors);

  return isValid;
};


  const handleNextStep = () => {
    if (currentStep < steps.length) {
      setCurrentStep((prev) => prev + 1);
    }
  };

  const handlePrevStep = () => {
    if (currentStep > 1) {
      setCurrentStep((prev) => prev - 1);
    }
  };



  const handleImageUpload = (event) => {
    const files = Array.from(event.target.files);
    setImages([...images, ...files]);
  };

  const handleVideoUpload = (event) => {
    const files = Array.from(event.target.files);
    setVideos([...videos, ...files]);
  };


  useEffect(() => {
    const fetchCoordinates = async () => {
      if (!locality.trim()) return;
      try {
        const response = await fetch(
          `https://nominatim.openstreetmap.org/search?format=json&q=${locality}, Chennai`
        );
        const data = await response.json();
        if (data.length > 0) {
          const lat = parseFloat(data[0].lat);
          const lon = parseFloat(data[0].lon);
          setPosition([lat, lon]);
          setAddress(data[0].display_name);
        } else {
          setAddress("Location not found");
        }
      } catch (error) {
        console.error("Error fetching coordinates:", error);
      }
    };

    if (locality) {
      fetchCoordinates();
    }
  }, [locality]);

  const wrapperRef = useRef(null);
  const navigate = useNavigate();

  const handleLookingToClick = (option) => {
    setLookingTo(option);

    // Redirect based on selection
    if (propertyType === "Residential" && option === "Rent") {
        navigate("/residential-rent");
    } else if (propertyType === "Residential" && option === "ReSale") {
        navigate("/residential-resell");
    } else if (propertyType === "Residential" && option === "PG/Co-living") {
        navigate("/");
    } else if (propertyType === "Commercial" && option === "Rent") {
        navigate("/Commercial-rent");
    } else if (propertyType === "Commercial" && option === "Resale") {
        navigate("/Commercial-resale");
    }
};

  const handleChange = (key, value) => {
    if (key === "availableFrom") {
      setavailableFrom(value);
    }
  };


  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setShowSuggestions(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Filter pincode suggestions based on the search term
  const filteredPincodes = pincodeData.filter(item =>
    item.pincode.includes(searchTerm)
  );

  // Handle changes in the pincode input field
  const handleInputChange = (e) => {
    setSearchTerm(e.target.value);
    setShowSuggestions(true);
    if (!e.target.value) setShowSuggestions(false);
  };

  // Handle selecting a pincode from suggestions
  const handleSelect = (pincode) => {
    setSelectedPincode(pincode);
    const selected = pincodeData.find(item => item.pincode === pincode);
    setLocalities(selected ? selected.locality : []);
    setShowSuggestions(false);
    setErrors({ ...errors, pincode: '' });
  };

  // Handle selecting a locality
  const handleLocalityChange = (event) => {
    setSelectedLocality(event.target.value);
    setErrors({...errors, selectedLocality: ''});
  };

  const propertyTypes = [
    "Apartment",
    "Independent Floor",
    "Independent House",
    "Villa",
    "Penthouse",
    "Duplex",
    "Studio",
    "Farm House",
  ];

  const bhkOptions = [
    "1 RK",
    "1 BHK",
    "1.5 BHK",
    "2 BHK",
    "2.5 BHK",
    "3 BHK",
    "3.5 BHK",
    "4 BHK",
    "4.5 BHK",
    "5 BHK",
    "5+ BHK",
  ];



  const handleSubmit = async () => {
    if (!validateForm()) {
      return;
    } 

    const formData = new FormData();
    formData.append("proptype", propertyType);
    formData.append("lookingto", lookingTo);
    formData.append("bpn", building);
    formData.append("city", "Chennai");
    formData.append("pincode", selectedPincode);
    formData.append("pinlocality", selectedLocality);
    formData.append("resiproptype", propertyType1);
    formData.append("buitupareasq", builtUpArea);
    formData.append("ageofproperty", propertyAge);
    formData.append("bathroom", bathroom);
    formData.append("balcony", balcony);
    formData.append("furnishtype", furnishType);
    formData.append("preferredtenanttype", tenantType);
    formData.append("petfriendly", petFriendly);
    formData.append("propertydes", propertyDescription);
    formData.append("availablefrom", availableFrom);
    formData.append("monthlyrent", monthlyrent);
    formData.append("maintenancecharge", maintenanceCharges);
    formData.append("securitydepo", securityDeposit);
    formData.append("lockinperiod", lockInPeriod);
    formData.append("brokeragcharge", brokerage);
    formData.append("carpetarea", carpetArea);
    formData.append("floorno", floorNo);
    formData.append("totalfloor", totalFloors);
    formData.append("Buildingdetails", BuildingDetails);
    formData.append("parkingcharges", parkingCharges);
    formData.append("paintingcharges", paintingCharges);
    formData.append("facing", facing);
    formData.append("addressaddlocality", Address);
    formData.append("addmapp", paraaddress);
    formData.append("transactiontype", "Rent");
    formData.append("constructionstatus", "Completed");
    formData.append("coveredparking", coveredParking);
    formData.append("openparking", openParking);
    formData.append("cost", monthlyrent);
    formData.append("servantroom", servantRoom);
    formData.append("flatfurnishings", furnishType);
    formData.append("societyamenities", "N/A");
    formData.append("agent_name", agent_name);
    formData.append("agent_id", agent_id);
    formData.append("fdt", new Date().toISOString());
    formData.append("status", "a");
  
    images.forEach((image, index) => {
      formData.append(`images`, image);
    });
  
    videos.forEach((video, index) => {
      formData.append(`video`, video);
    });
  
    try {
      const response = await axios.post("/add-property", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      console.log(response.data);
      alert("Property added successfully");
    } 
    catch (error) {
      console.error("Error submitting form:", error);
      alert("Failed to add property. Please try again.");
    }
  };

  return (
    <div>

       <Dashboard />
    <div className="postprop" >

         {/* Sidebar */}
         <div className="sidebar">
        <h2>Post your property</h2>
        <p>Welcome! &nbsp; {agent_name} || {agent_id}</p>
        <p>ReSell or rent your property</p>

        <div className="timeline">
          {steps.map((step) => (
            <div key={step.id} className={`step ${step.id < currentStep ? "complete" : step.id === currentStep ? "active" : ""}`}>
              <div className="circle">{step.id < currentStep ? "✓" : step.id}</div>
              <div className="label">
                <p>{step.label}</p>
                <span>{step.id < currentStep ? "Completed" : step.id === currentStep ? "In progress" : "Pending"}</span>
              </div>
            </div>
          ))}
        
        </div>
        <span>need help: call +91 9585973683</span>
      </div>

      {/* Add PG/Co-living Properties */}
      <div className="form-section">
      <div className="form-container ">
      
      {currentStep === 1 && (
          <div>
              <h2 className="text-xl font-semibold mb-4"><u>Add Property Details</u></h2>

              {/* Property Type */}
              <div className="mb-4" ref={propertyTypeRef}>
                <p className="mb-2 font-medium">Property Type *</p>
                <div className=" button-group">
                  <button
                    className={`button ${propertyType === "Residential" ? "selected" : ""}`}
                    onClick={() => {
                      setPropertyType("Residential");
                      setErrors({ ...errors, propertyType: '' });
                    }}
                    required
                  >
                    Residential
                  </button>
                  <button
                    className={`button ${propertyType === "Commercial" ? "selected" : ""}`}
                    onClick={() => {
                      setPropertyType("Commercial");
                      setErrors({ ...errors, propertyType: '' });
                    }}
                    required
                  >
                    Commercial
                  </button>
                </div>
                {errors.propertyType &&(
                  <span style={{color: 'red',fontSize: '0.8rem'}}
                  className='text-sm'>
                    {errors.propertyType}
                  </span>
                )}
              </div>

              {/* Looking To */}
              <div className="mb-4" ref={lookingToRef}>
                <p className="mb-2 font-medium">Looking to *</p>
                <div className=" button-group">
                  {(propertyType === "Residential"
                    ? ["Rent", "ReSale", "PG/Co-living"]
                    : ["Rent", "ReSale"]
                  ).map((option) => (
                    <button
                      key={option}
                      className={`btnsmall ${lookingTo === option ? "btnsmall-selected" : "" }`}
                      onClick={() => {
                        handleLookingToClick(option);
                      setErrors({...errors,lookingTo:''});
                      }}
                      required
                    >
                      {option}
                    </button>
                  ))}
                </div>
                {errors.lookingTo && (
        <span style={{ color: 'red',fontSize: '0.8rem' }}
        className="text-sm">{errors.lookingTo}
        </span>
    )}
              </div>

                  {/* Enter city */}
                  <div className="mb-4" ref={cityRef}>
                  <label className='block mb-2 font-medium'>Enter City *</label>
                  <input
        type="text"
        value={city}
        onChange={(e) => {
            setCity(e.target.value);
            setErrors({ ...errors, city: '' }); // Clear error on change
        }}
        className={`w-full border p-2 rounded-lg ${errors.city ? 'border-red-500' : ''}`} // Added conditional border
        placeholder="Enter City"
        required
    />
    {errors.city && (
        <span style={{ color: 'red',fontSize: '0.8rem' }} 
        className="text-sm"> {/* Adjusted error span */}
            {errors.city}
        </span>
    )}
                </div>

              {/* Building Details */}
              <div className="mb-4" ref={buildingRef}>
              <label className='block mb-2 font-medium'>Building Details *</label>
                <input
                  type="text"
                  value={building}
                  onChange={(e) => {
                    setBuilding(e.target.value);
                    setErrors({...errors, building:''});
                  }}
                  className="w-full border p-2 rounded-lg"
                  placeholder=  "Building/Project/Society"
                  required
                />
                {errors.BuildingDetails && (
                  <span style={{ color: 'red',fontSize: '0.8rem' }} 
                  className="text-sm">
                    {errors.building}
                  </span>
                )}
              </div>


              {/* pincode */}
              <div className="mb-4" ref={pincodeRef}>
                <label className='block mb-2 font-medium' htmlFor="pincode">Enter Pincode *</label>
                <input
                  type="number"
                  id="pincode"
                  className="w-full border p-2 rounded-lg"
                  value={selectedPincode || searchTerm}
                  onChange={handleInputChange}
                  placeholder="Type pincode"
                  autoComplete="off"
                  required
                  inputMode="numeric"
                  maxLength={6} // Stops extra input
                />
                  {errors.pincode && (
                  <span style={{ color: 'red',fontSize: '0.8rem' }} 
                  className="text-sm">{errors.pincode}
                  </span>
                )}
              </div>

              {/* Suggestions dropdown for pincode */}
              {showSuggestions && (
                <div className="suggestions-dropdown shadow-sm mb-4">
                  {filteredPincodes.length > 0 ? (
                    filteredPincodes.map((item) => (
                      <div
                        key={item.pincode}
                        className="suggestion-item"
                        onClick={() => {
                          handleSelect(item.pincode);
                        setErrors({...errors,pincode:''});
                      }}
                      >
                        <div className="pincode">{item.pincode}</div>
                        <div className="area">{item.area}</div>
                      </div>
                    ))
                  ) : (
                    <div className="no-results">No pincodes found</div>
                  )}
                </div>
              )}

              {/* After selecting pincode, show locality dropdown */}
              {selectedPincode && (
                <>
                  <div className="mb-4">
                    <label className='block mb-2 font-medium' htmlFor="locality">Select Locality:</label>
                    <select
                      id="locality"
                      value={selectedLocality}
                      onChange={handleLocalityChange}
                      className="w-full border p-2 rounded-lg"
                    >
                      <option value="">Select a locality</option>
                      {localities.map((locality, index) => (
                        <option key={index} value={locality}>
                          {locality}
                        </option>
                      ))}
                    </select>
                  </div>
                  {errors.selectedLocality && (
                  <span style={{ color: 'red',fontSize: '0.8rem' }} 
                  className="text-sm">{errors.selectedLocality}
                  </span>
                )}
                </>
              )}

             {/* Property Type Selection */} 
             <h2 className="text-xl font-semibold mb-4">Property Details</h2>
              <div className="mb-4" ref={propertyType1Ref}>
                <label className="block mb-2 font-medium">Property Type *</label>
                <div className=" button-group">
                  {propertyTypes.map((type) => (
                    <button
                      key={type}
                      type="button"
                      className={`grid-item ${propertyType1 === type ? "active" : "bg-gray-200"
                        }`}
                      onClick={() => {
                        setPropertyType1(type);
                        setErrors({...errors,propertyType1:''});
                      }}
                      required
                    >
                      {type}
                    </button>
                  ))}
                </div>
                {errors.propertyType1 && (
                  <span style={{ color: 'red',fontSize: '0.8rem' }} 
                  className="text-sm">{errors.propertyType1}
                  </span>
                )}
              </div>


              {/* BHK Selection */}
              <div className="mb-4" ref={bhkTypeRef}>
                <label className="block mb-2 font-medium">BHK *</label>
                <div className=" button-group">
                  {bhkOptions.map((bhk) => (
                    <button
                      key={bhk}
                      className={`grid-item ${bhkType === bhk ? "active" : "bg-gray-200"
                        }`}
                      onClick={() => {
                        setBhkType(bhk);
                        setErrors({...errors,bhkType:''});
                      }}
                      required
                    >
                      {bhk}
                    </button>
                  ))}
                </div>
                {errors.bhkType && (
                  <span style={{ color: 'red',fontSize: '0.8rem' }} 
                  className="text-sm">{errors.bhkType}
                  </span>
                )}
              </div>

              {/* Built-up Area Input */}
              <div className="mb-4" ref={builtUpAreaRef}>
                <label className="block mb-2 font-medium">Built-Up Area (sq. ft.) *</label>
                <input
                  type="number"
                  value={builtUpArea}
                  onChange={(e) => {
                    setBuiltUpArea(e.target.value);
                    setErrors({...errors,builtUpArea:''});
                  }}
                  className="w-full p-2 border rounded-lg"
                  placeholder="Enter area in sq. ft."
                  required
                  min="1"
                />
                {errors.builtUpArea && (
                  <span style={{ color: 'red',fontSize: '0.8rem' }} className="text-sm">{errors.builtUpArea}</span>
                  )}
                </div>

             {/* Age of Property Input */}
             <div className="mb-4" ref={propertyAgeRef}>
                <label className="block mb-2 font-medium">Age of Property (years) *</label>
                <input
                  type="number"
                  value={propertyAge}
                  onChange={(e) => {
                    setPropertyAge(e.target.value);
                    setErrors({ ...errors, propertyAge: '' }); // Clear error on change
                }}
                className={`w-full p-2 border rounded-lg ${errors.propertyAge ? 'border-red-500' : ''}`}
                placeholder="Enter property age"
                required
            />
            {errors.propertyAge && (
                <span style={{ color: 'red',fontSize: '0.8rem' }} className="absolute text-red-500 text-sm top-full left-0">
                    {errors.propertyAge}
                </span>
            )}
              </div>

 {/* Bathroom */}
 <div className="my-4" ref={bathroomRef}>
  <label className="block font-medium">Bathroom *</label>
  <div className="button-group">
    {[1, 2, 3, 4].map((num) => (
      <button
        key={num}
        className={`grid-item ${bathroom === num ? "active" : ""}`}
        onClick={() => {
          setBathroom(num);
          setErrors({ ...errors, bathroom: '' }); // Clear error
      }}
      required
      >
        {num}
      </button>
    ))}
  </div>
  {errors.bathroom && (
    <span style={{ color: 'red',fontSize: '0.8rem' }} className="text-sm">{errors.bathroom}</span>
    )}
</div>

{/* Balcony */}
<div className="my-4" ref={balconyRef}>
  <label className="block font-medium">Balcony *</label>
  <div className="button-group">
    {[0, 1, 2, 3].map((num) => (
      <button
        key={num}
        className={`grid-item ${balcony === num ? "active" : ""}`}
        onClick={() => {
          setBalcony(num);
          setErrors({ ...errors, balcony: '' });
        }}
        required
      >
        {num}
      </button>
    ))}
  </div>
  {errors.balcony && (
    <span style={{ color: 'red',fontSize: '0.8rem' }} 
    className="text-sm">{errors.balcony}
    </span>
    )}
</div>

             {/* Furnish Type */}
             <div className="my-4" ref={furnishTypeRef}>
                <label className="block font-medium">Furnish Type *</label>
                <div className=" button-group">
                  {["Fully Furnished", "Semi Furnished", "Unfurnished"].map((type) => (
                    <button key={type} 
                    className={`grid-item ${furnishType === type ? "active" : ""}`} 
                    onClick={() => {
                      setFurnishType(type)
                      setErrors({ ...errors, furnishType: '' });
                    }}
                    required
                    >
                    {type}
                    </button>
                  ))}
                </div>
                {errors.furnishType && (
                  <span style={{ color: 'red',fontSize: '0.8rem' }} className="text-sm">{errors.furnishType}</span>
                  )}
              </div>

            {/* Preferred Tenant Type */}
<div className="my-4" ref={tenantTypeRef}>
  <label className="block font-medium">Preferred Tenant Type *</label>
  <div className="button-group">
    {["Family", "Bachelors", "Company"].map((type) => (
       <button key={type} 
       className={`grid-item ${tenantType === type ? "active" : ""}`} 
       onClick={() => {
         setTenantType(type)
         setErrors({ ...errors, tenantType: '' });
       }}
       required
       >
        {type}
      </button>
    ))}
  </div>
 
  {errors.tenantType && (
                  <span style={{ color: 'red',fontSize: '0.8rem' }} className="text-sm">{errors.tenantType}</span>
                  )}
</div>

             {/* Pet Friendly */}
<div className="my-4" ref={petFriendlyRef}>
  <label className="block font-medium">Pet Friendly? *</label>
  <div className="button-group">
    {["Yes", "No"].map((option) => (
      <button
        key={option}
        className={`grid-item ${petFriendly === option ? "active" : ""}`}
        onClick={() => {
          setPetFriendly(option);
          setErrors({ ...errors, petFriendly: '' });
        }}
        required
      >
        {option}
      </button>
    ))}
  </div>
  {errors.petFriendly && (
    <span style={{ color: 'red',fontSize: '0.8rem' }} className="text-sm">
      {errors.petFriendly}
    </span>
  )}
</div>

              {/* Description */}
<div className="my-4 relative" ref={propertyDescriptionRef}>
  <label className="block font-medium">Property Description *</label>
  <textarea
    className={`w-full border rounded-lg p-2 ${errors.propertyDescription ? 'border-red-500' : ''}`}
    rows="3"
    value={propertyDescription}
    onChange={(e) => {
      setPropertyDescription(e.target.value);
      setErrors({ ...errors, propertyDescription: '' });
    }}
  ></textarea>
  {errors.propertyDescription && (
    <span className="text-sm" style={{ color: 'red',fontSize: '0.8rem' }}>
      {errors.propertyDescription}
    </span>
  )}
</div>


              {/* Monthly Rent */}
              <div className="my-4" ref={monthlyrentRef}>
                <label className="block font-medium">Monthly Rent *</label>
                <input
                  type="number"
                  className="w-full border rounded-lg p-2"
                  value={monthlyrent}
                  onChange={(e) => {
                    setMonthlyrent(e.target.value);
                    setErrors({ ...errors, monthlyrent: '' });
                  }}
                  required
                />
                {errors.monthlyrent && (
                  <span style={{ color: 'red',fontSize: '0.8rem' }} className="text-sm">{errors.monthlyrent}</span>
                  )}
              </div>

              {/* Maintenance Charges */}
              <div className="my-4" ref={maintenanceChargesRef}>
                <label className="block font-medium">Maintenance Charges *</label>
                <div className=" button-group">
                  {["Include in rent", "Separate"].map((option) => (
                    <button 
                    key={option} 
                    className={`grid-item ${maintenanceCharges === option ? "active" : ""}`} 
                    onClick={() => {
                      setMaintenanceCharges(option)
                      setErrors({...errors, maintenanceCharges:''});
                    }}
                    required
                    >{option}
                    </button>
                  ))}
                </div>
                {errors.maintenanceCharges && (
                  <span style={{ color: 'red',fontSize: '0.8rem' }} className="text-sm">{errors.maintenanceCharges}</span>
                  )}
              </div>

              {/* Security Deposit */}
              <div className="my-4" ref={securityDepositRef}>
                <label className="block font-medium">Security Deposit *</label>
                <div className=" button-group">
                  {["None", "1 month", "2 month", "Custom"].map((option) => (
                    <button 
                    key={option} 
                    className={`grid-item ${securityDeposit === option ? "active" : ""}`} 
                    onClick={() => {
                      setSecurityDeposit(option)
                      setErrors({...errors,securityDeposit})
                    }}
                    required
                    >{option}
                    </button>
                  ))}
                </div>
                {errors.securityDeposit && (
                  <p style={{ color: 'red',fontSize: '0.8rem' }} className="text-sm">{errors.securityDeposit}</p>
                  )}
              </div>

             {/* Lock-in Period */}
             <div className="my-4" ref={lockInPeriodRef}>
                <label className="block font-medium">Lock-in Period *</label>
                <div className=" button-group">
                  {["None", "1 month", "6 month", "Custom"].map((option) => (
                    <button 
                    key={option} 
                    className={`grid-item ${lockInPeriod === option ? "active" : ""}`} 
                    onClick={() => {
                      setLockInPeriod(option)
                      setErrors({...errors,lockInPeriod})
                    }}
                    required
                    >
                      {option}
                      </button>
                  ))}
                </div>
                {errors.lockInPeriod && (
                  <p style={{ color: 'red',fontSize: '0.8rem' }} className="text-sm">{errors.lockInPeriod}</p>
                  )}
              </div>

             {/* Brokerage */}
             <div className="my-4" ref={brokerageRef}>
                <label className="block font-medium">Do you charge brokerage? *</label>
                <div className=" button-group">
                  {["yes","No"].map((option) => (
                    <button 
                    key={option} 
                    className={`grid-item ${brokerage === option ? "active" : ""}`} 
                    onClick={() => {
                      setBrokerage(option)
                      setErrors({...errors.brokerage})
                    }}
                    required
                    >
                      {option}
                      </button>
                  ))}
                </div>
                {errors.brokerage && (
                  <p style={{ color: 'red', fontSize: '0.8rem' }} className="text-sm">{errors.brokerage}</p>
                  )}
              </div>

              {/* Carpet Area */}
              <div className="my-4" ref={carpetAreaRef}>
                <label className="block font-medium">Carpet Area *</label>
                <input 
                type="number" 
                className="w-full border rounded-lg p-2" 
                placeholder="Sq. ft." 
                value={carpetArea} 
                onChange={(e) => {
                  setCarpetArea(e.target.value);
                  setErrors({...errors,carpetArea:''});
                }}
                required 
                />
                {errors.carpetArea && (
                  <span style={{ color: 'red', fontSize: '0.8rem' }} className="text-sm">{errors.carpetArea}</span>
                  )}
              </div>

             {/* Floor Number */}
             <div className="my-4" ref={floorNoRef}>
                <label className="block font-medium">Floor No. *</label>
                <input 
                type="number" 
                className="w-full border rounded-lg p-2" 
                placeholder="Enter floor number"
                value={floorNo} 
                onChange={(e) => {
                  setFloorNo(e.target.value);
                  setErrors({...errors,floorNo:''});
                }} 
                required 
                />
                {errors.floorNo && (
                  <span style={{ color: 'red', fontSize: '0.8rem' }} className="text-sm">{errors.floorNo}</span>
              )}
              </div>

              {/* Total Floor */}
              <div className="my-4" ref={totalFloorsRef}>
                <label className="block font-medium">Total Floors *</label>    
                <input 
                  type="number"
                  className="w-full border rounded-lg p-2 my-2"
                  placeholder="Enter total floors"
                  value={totalFloors}
                  onChange={(e) => {
                    setTotalFloors(e.target.value);
                    setErrors({...errors,totalFloors:''});
                  }}
                  required
                />
                {errors.totalFloors && (
                  <span style={{ color: 'red', fontSize: '0.8rem' }} className="text-sm">{errors.totalFloors}</span>
              )}
              </div>
              {/* Image Upload Section */}
              <div className="mb-4">
                <label className="block mb-2 font-medium">Upload Images</label>
                <input type="file" accept="image/*" multiple onChange={handleImageUpload} className="w-full p-2 border rounded-lg" />
                <div className="grid grid-cols-3 gap-2 mt-2">
                  {images.map((image, index) => (
                    <img key={index} src={URL.createObjectURL(image)} alt="Uploaded" className="w-full h-20 object-cover rounded-lg" />
                  ))}
                </div>
              </div>

              {/* Video Upload Section */}
              <div className="mb-4">
                <label className="block mb-2 font-medium">Upload Videos</label>
                <input type="file" accept="video/*" multiple onChange={handleVideoUpload} className="w-full p-2 border rounded-lg" />
                <div className="grid grid-cols-2 gap-2 mt-2">
                  {videos.map((video, index) => (
                    <video key={index} controls className="w-full h-32 rounded-lg">
                      <source src={URL.createObjectURL(video)} type="video/mp4" />
                    </video>
                  ))}
                </div>
              </div>



              {/* Expandable Section */}
              <div className="additional">
                <button
                  className="addbtn"
                  onClick={() => setShowAdditional(!showAdditional)}
                >
                  Add Additional Details
                  <span>{showAdditional ? "▲" : "▼"}</span>
                </button>

                {showAdditional && (
                  <div className="p-4">
                    {/* Parking Charges */}
                    <div className="my-4">
                      <label className="block font-medium">Parking Charges</label>
                      <div className=" button-group">
                        {["Include in rent", "Separate"].map((option) => (
                          <button
                            key={option}
                            className={`grid-item ${parkingCharges === option ? "active" : ""
                              }`}
                            onClick={() => setParkingCharges(option)}
                          >
                            {option}
                          </button>
                        ))}
                      </div>
                    </div>

                    {/* Painting Charges */}
                    <div className="my-4">
                      <label className="block font-medium">Painting Charges</label>
                      <div className=" button-group">
                        {["None", "As per cost", "1 month", "Custom"].map((option) => (
                          <button
                            key={option}
                            className={`grid-item ${paintingCharges === option ? "active" : ""
                              }`}
                            onClick={() => setPaintingCharges(option)}
                          >
                            {option}
                          </button>
                        ))}
                      </div>
                    </div>

                    {/* Facing Direction */}
                    <div className="my-4">
                      <label className="block font-medium">Facing</label>
                      <div className="grid grid-cols-3 gap-2">
                        {["North", "East", "West", "South", "North - East", "North - West", "South - East", "South - West"].map(
                          (option) => (
                            <button
                              key={option}
                              className={`grid-item ${facing === option ? "active" : ""
                                }`}
                              onClick={() => setFacing(option)}
                            >
                              {option}
                            </button>
                          )
                        )}
                      </div>
                    </div>

                  
                  </div>
                )}
              </div>




              {/* Next Button
              <button onClick={() => setStep(2)}  className="next-button">
                Next, add address details
              </button> */}


            </div>
          )}

          {/* -------------------------------------------------------Add Address---------------------------------------------------------- */}


          {currentStep === 2 && (
          <div>
              <h2 className="text-lg font-semibold">Add Address</h2>
              <p className="text-gray-600">Locality / Sector *</p>
              <input
                type="text"
                className="w-full border rounded-lg p-2 my-2"
                value={selectedLocality}
                onChange={(e) => setLocality(e.target.value)}
                placeholder="Enter loacation the property.."
              />

              <h3 className="text-md font-medium mt-4">Where is your property located?</h3>
              <p className="text-sm text-gray-500">
                Search for a location or click on the map to select manually.
              </p>

              <div className="mapcontainer">
                <MapContainer center={position} zoom={14} style={{ height: "400px", width: "100%", alignItems: "center" }}>
                  <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                  <Marker position={position} icon={customIcon}>
                    <Popup>{paraaddress || "Click on the map to select location"}</Popup>
                  </Marker>
                  <LocationSelector setPosition={setPosition} setAddress={setAddress} />
                </MapContainer>
              </div>

              <p className="mt-2 text-gray-700 md-6">
                <strong>Selected Address:</strong> {Address}
              </p>

              {/* <button onClick={handleSubmit} className="next-button">
                Post Property
              </button> */}
            </div>
          )}


<div className="button-group">
  {currentStep > 1 && (
    <button onClick={handlePrevStep} className="button prev">
      Back
    </button>
  )}
  {currentStep < steps.length ? (
    <button
      onClick={() => {
        if (validateForm()) {
          handleNextStep();
        } else {
          // Find the first error field and scroll to it
          const firstErrorKey = Object.keys(errors).find((key) => errors[key]);
          if (firstErrorKey) {
            const errorRef = getRefByKey(firstErrorKey); // Implement getRefByKey()
            if (errorRef && errorRef.current) {
              errorRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          }
        }
      }}
      className="button next"
    >
      Next
    </button>
  ) : (
    <button onClick={handleSubmit} className="button submit">
      Submit
    </button>
  )}
</div>
        </div>
      </div>
    </div>
    </div>
  )
}
